var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 8.88501H3.508C2.77653 8.88501 2.07502 9.17558 1.5578 9.69281C1.04057 10.21 0.75 10.9115 0.75 11.643V13.022",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63709 3.508C8.63709 4.05344 8.47537 4.58663 8.17236 5.04016C7.86935 5.49369 7.43867 5.84719 6.93477 6.05596C6.43087 6.26474 5.87638 6.31942 5.3414 6.21308C4.80643 6.10674 4.315 5.84417 3.92925 5.45855C3.5435 5.07294 3.28074 4.58161 3.17421 4.04667C3.06768 3.51174 3.12216 2.95723 3.33075 2.45325C3.53934 1.94928 3.89269 1.51847 4.3461 1.21529C4.79952 0.91212 5.33266 0.750198 5.8781 0.75C6.60956 0.75 7.31107 1.04057 7.8283 1.5578C8.34552 2.07502 8.63609 2.77653 8.63609 3.508H8.63709Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40039 8.896H14.6504C14.8493 8.896 15.0401 8.97501 15.1807 9.11567C15.3214 9.25632 15.4004 9.44708 15.4004 9.646V12.271C15.4004 12.4699 15.3214 12.6607 15.1807 12.8013C15.0401 12.942 14.8493 13.021 14.6504 13.021H9.40039C9.20148 13.021 9.01071 12.942 8.87006 12.8013C8.72941 12.6607 8.65039 12.4699 8.65039 12.271V9.646C8.65039 9.44708 8.72941 9.25632 8.87006 9.11567C9.01071 8.97501 9.20148 8.896 9.40039 8.896Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1504 8.89601V7.39601C10.1504 6.89859 10.348 6.42155 10.6997 6.06983C11.0514 5.7181 11.5285 5.52051 12.0259 5.52051C12.5233 5.52051 13.0003 5.7181 13.3521 6.06983C13.7038 6.42155 13.9014 6.89859 13.9014 7.39601V8.89601",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.07e661ebb4813b9eef257951daef6807.svg";
export { ForwardRef as ReactComponent };